import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/* eslint-disable react/prop-types */
var Check = function Check(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: "36",
    height: "36",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Checkmark Icon"
    }), /*#__PURE__*/_jsx("path", {
      "aria-hidden": "true",
      d: "M12.586 24l-2.829-2.828 1.415-1.415L14 22.586l11.314-11.314 1.414 1.414L14 25.414 12.586 24z",
      fillRule: "evenodd"
    })]
  });
};

export default Check;